/**
 * ADMIN PATH
 */
export const ADMIN_LAYOUT_PATH = '/admin';
export const DASHBOARD_PATH = '/dashboard';
export const SURVEY_PATH = '/my-surveys';
export const ARCHIVED_SURVEY_PATH = `${SURVEY_PATH}/archived`;
export const ADD_SURVEY_PATH = `${SURVEY_PATH}/add`;
export const EDIT_SURVEY_PATH = `${SURVEY_PATH}/:id/edit`;
export const RESULT_SURVEY_PATH = `${SURVEY_PATH}/:id/result`;
export const GIV_RESULT_SURVEY_PATH = `${SURVEY_PATH}/:id/result/gather-index-value`;
export const GIV_BENCHMARKING_PATH = `${SURVEY_PATH}/:id/result/giv-benchmarking`;
export const RESPONSE_SURVEY_PATH = `${SURVEY_PATH}/:surveyId/response/:id`;
export const ADD_QUESTION_PATH = `${SURVEY_PATH}/:surveyId/question/add`;
export const EDIT_QUESTION_PATH = `${SURVEY_PATH}/:surveyId/question/:id/edit`;
export const USER_TEMPLATE_PATH = '/my-templates';
export const SELECT_TEMPLATE_PATH = '/select-template';
export const GATHER_TEMPLATE_PATH = '/gather-templates';
export const ADD_USER_TEMPLATE_PATH = `${USER_TEMPLATE_PATH}/add`;
export const ADD_GATHER_TEMPLATE_PATH = `${GATHER_TEMPLATE_PATH}/add`;
export const EDIT_USER_TEMPLATE_PATH = `${USER_TEMPLATE_PATH}/:id/edit`;
export const EDIT_GATHER_TEMPLATE_PATH = `${GATHER_TEMPLATE_PATH}/:id/edit`;
export const ADD_USER_TEMPLATE_QUESTION_PATH = `${USER_TEMPLATE_PATH}/:surveyId/question/add`;
export const ADD_GATHER_TEMPLATE_QUESTION_PATH = `${GATHER_TEMPLATE_PATH}/:surveyId/question/add`;
export const EDIT_USER_TEMPLATE_QUESTION_PATH = `${USER_TEMPLATE_PATH}/:surveyId/question/:id/edit`;
export const EDIT_GATHER_TEMPLATE_QUESTION_PATH = `${GATHER_TEMPLATE_PATH}/:surveyId/question/:id/edit`;
export const PRESET_DATA_PATH = '/preset-data';
export const ADD_PRESET_DATA_PATH = `${PRESET_DATA_PATH}/add`;
export const EDIT_PRESET_DATA_PATH = `${PRESET_DATA_PATH}/:id/edit`;
export const TEAM_MEMBER_PATH = '/company';
export const INVITE_TEAM_MEMBER_PATH = `${TEAM_MEMBER_PATH}/invite`;
export const EDIT_TEAM_MEMBER_PATH = `${TEAM_MEMBER_PATH}/:id/edit`;
export const SUBSCRIPTION_PATH = '/subscription';
export const ACCOUNT_PATH = '/account';
export const DASHBOARD_FULL_PATH = `${ADMIN_LAYOUT_PATH}${DASHBOARD_PATH}`;
export const SURVEY_FULL_PATH = `${ADMIN_LAYOUT_PATH}${SURVEY_PATH}`;
export const USER_TEMPLATE_FULL_PATH = `${ADMIN_LAYOUT_PATH}${USER_TEMPLATE_PATH}`;
export const SELECT_TEMPLATE_FULL_PATH = `${ADMIN_LAYOUT_PATH}${SELECT_TEMPLATE_PATH}`;
export const GATHER_TEMPLATE_FULL_PATH = `${ADMIN_LAYOUT_PATH}${GATHER_TEMPLATE_PATH}`;
export const ADD_USER_TEMPLATE_FULL_PATH = `${ADMIN_LAYOUT_PATH}${ADD_USER_TEMPLATE_PATH}`;
export const ADD_GATHER_TEMPLATE_FULL_PATH = `${ADMIN_LAYOUT_PATH}${ADD_GATHER_TEMPLATE_PATH}`;
export const ARCHIVED_SURVEY_FULL_PATH = `${ADMIN_LAYOUT_PATH}${ARCHIVED_SURVEY_PATH}`;
export const ADD_SURVEY_FULL_PATH = `${ADMIN_LAYOUT_PATH}${ADD_SURVEY_PATH}`;
export const PRESET_DATA_FULL_PATH = `${ADMIN_LAYOUT_PATH}${PRESET_DATA_PATH}`;
export const TEAM_MEMBER_FULL_PATH = `${ADMIN_LAYOUT_PATH}${TEAM_MEMBER_PATH}`;
export const SUBSCRIPTION_FULL_PATH = `${ADMIN_LAYOUT_PATH}${SUBSCRIPTION_PATH}`;
export const ACCOUNT_FULL_PATH = `${ADMIN_LAYOUT_PATH}${ACCOUNT_PATH}`;

/**
 * AUTH PATH
 */
export const AUTH_LAYOUT_PATH = '/auth';
export const LOGIN_PATH = '/login';
export const REGISTER_PATH = '/register';
export const FORGOT_PASSWORD_PATH = '/forgot';
export const RESET_PASSWORD_PATH = '/reset-password';
export const LOGIN_FULL_PATH = `${AUTH_LAYOUT_PATH}${LOGIN_PATH}`;
export const REGISTER_FULL_PATH = `${AUTH_LAYOUT_PATH}${REGISTER_PATH}`;
export const FORGOT_PASSWORD_FULL_PATH = `${AUTH_LAYOUT_PATH}${FORGOT_PASSWORD_PATH}`;

/**
 * OTHER PATH
 */
export const VERIFY_EMAIL_UPDATE_PATH = '/verify-email-update';
export const VERIFY_PATH = '/verify';
